export default __webpack_public_path__ + "static/media/grab_area.a4b66b99.svg";